import { fetcher } from '@commenda/utils';
import { LocationType } from '@prisma/client';
import { TAddressParams } from '../business-entity';

export enum KeyPersonDesignation {
  //corps
  DIRECTOR = 'DIRECTOR',
  SECRETARY = 'Secretary',
  TREASURER = 'Treasurer',
  PRESIDENT = 'President',

  // limited by liability
  DESIGNATED_PARTNER = 'DESIGNATED_PARTNER',
  PARTNER = 'PARTNER',
  MEMBER = 'MEMBER',
}

type FilePayload = {
  fileName: string;
  fileUrl: string;
  documentType: string;
};

type TCreateKeyPersonParams = {
  companyId: number;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  dateOfBirth?: string;
  locations?: {
    locationTypes: LocationType[];
    address: TAddressParams;
  }[];
  governmentId?: FilePayload;
  panCard?: FilePayload;
  aadharCard?: FilePayload;
  addressProof?: FilePayload;
  dscProof?: FilePayload;
  bankTransferProof?: FilePayload;
  directorIdentificationNumber?: string;
};

export const createKeyPerson = async (body: TCreateKeyPersonParams) => {
  const res = await fetcher('persons', {
    method: 'POST',
    body,
  });

  return res;
};
